

import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { registerLocale } from "react-datepicker";
import * as R from 'ramda';
import contriesList from 'iso-3166-1-alpha-2';
import fr from "date-fns/locale/fr";
import liendirect from './../../assets/images/svg/049-family.svg';
import autres from './../../assets/images/svg/051-parents.svg';
import { updateRepresentative, addUserRepresentative, addUserRepresentativeAddress, updateUserRepresentativeAddress} from '../../actions/user-api';
import { useDispatch, useSelector } from 'react-redux';
import {RegexFields} from '../../constants/utils/regexFields';
import {DateWithModal} from '../dateWithModal';
import {DeleteModal} from './deleteModal';
import {PostalCityInput} from '../postalCityInput';
import countryTelData from 'country-telephone-data';
import {isValidPhoneNumber} from 'libphonenumber-js';
import parsePhoneNumber from 'libphonenumber-js';

export const EditReferent = ({ data, isNew, inModal, isEditing, setIsEditing, setNewReferent, refIndex, authFacilitaPage}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    registerLocale("fr", fr);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const [wasValidated, setWasValidated] = useState(false);
    //#region form
    const referentForm = useRef(null);
    const gender = { male: 'Male', female: 'Female' };
    const representativeType = {child: 'Child', parent:'Parent', sibling:'Sibling', spouse:'Spouse', other:'Other'};

    let parsedPhoneNumber = undefined;
    if(!R.isNil(data.phoneNumber)){
        parsedPhoneNumber = parsePhoneNumber(data.phoneNumber);
    }

    const [referentData, setReferentData] = useState({
        id: !R.isNil(data) && !R.isNil(data.id)? data.id : undefined,
        gender: !R.isNil(data) && !R.isNil(data.gender) ? data.gender : undefined,
        firstName: !R.isNil(data) && !R.isNil(data.firstName) ? data.firstName : '',
        lastName: !R.isNil(data) && !R.isNil(data.lastName) ? data.lastName : '',
        birthDate: !R.isNil(data) && !R.isNil(data.birthDate) ? new Date(data.birthDate) : undefined,
        email: !R.isNil(data) && !R.isNil(data.email) ? data.email : '',
        representativeType: !R.isNil(data) && !R.isNil(data.representativeType)? data.representativeType : undefined,
        isLienFamilialDirect: !R.isNil(data) && !R.isNil(data.representativeType) && (
            data.representativeType === representativeType.child ||
            data.representativeType === representativeType.parent ||
            data.representativeType === representativeType.sibling
            ) ? true: false,
        isMainRepresentative: !R.isNil(data) && !R.isNil(data.isMainRepresentative)? data.isMainRepresentative : false,
        country: !R.isNil(data) && !R.isNil(data.address) && !R.isNil(data.address.country) ? data.address.country : 'FR',
        city: !R.isNil(data) && !R.isNil(data.address) && !R.isNil(data.address.city) ? data.address.city : '',
        zipCode: !R.isNil(data) && !R.isNil(data.address) && !R.isNil(data.address.postalCode)? data.address.postalCode : '',
        address: !R.isNil(data) && !R.isNil(data.address) && !R.isNil(data.address.addressLine1)? data.address.addressLine1 : '',
        tmpRef: !R.isNil(data) && !R.isNil(data.tmpRef) ? data.tmpRef : undefined,
        countryCode: !R.isNil(parsedPhoneNumber) ? parsedPhoneNumber.countryCallingCode : '33',
        phoneCountry: !R.isNil(parsedPhoneNumber) ? parsedPhoneNumber.country : 'FR',
        phoneNumber: !R.isNil(parsedPhoneNumber) ? parsedPhoneNumber.formatNational() : ''
    });


    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //#endregion
        
    return (
        <div className={isNew === true ? '' : (authFacilitaPage ? "card border border-light p-4 mb-3" : "card card-body pb-0 shadow mb-4")}>
            {isNew === true  ||  authFacilitaPage ? '' :
                <h2 className="h4 text-secondary font-weight-bolder mt-2 mb-3">{referentData.isMainRepresentative === true ? '' : 'AUTRE'} RÉFÉRENT {referentData.isMainRepresentative === true ? 'PRINCIPAL *' : ''}</h2>
            }
            {referentData.isMainRepresentative === true ?
                <React.Fragment>
                    <p className="h5 o-80 lh-copy mb-4">Votre Référent Principal est la personne qui aura accès et qui validera l’envoi des courriers obligatoires le moment venu.</p>
                    <p className="h5 o-80 lh-copy">Le Référent sera averti par mail et par SMS annuellement de votre démarche mais n’aura pas accès aux informations de votre dossier (comptes bancaires, contrats d’assurances...).</p>
                    <hr className="my-3" />
                </React.Fragment>
                :
                ''
            }
            <form className={authFacilitaPage ? "block" : "py-sm"} noValidate ref={referentForm}>
                <div className="form-row mb-3">
                    <div className="form-group col-12 col-sm">
                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Email" + refIndex}>Email</label>
                        <input type="email" className="form-control" id={"Email" + refIndex} defaultValue={referentData.email} onChange={(event) => {
                            setReferentData({ ...referentData, email: event.target.value })
                        }} pattern={RegexFields.email} />
                    </div>
                </div>

                <div className="form-group container-copy">
                    <label className="h6 font-weight-bolder my-auto" htmlFor={"Telephone" + refIndex}>Numéro de portable</label>
                    <div className="input-group mb-0">
                        <select className="custom-select rounded container-tiny mr-2" id={"phonecode" + refIndex} tabIndex={-98} value={referentData.countryCode} onChange={(event) => {
                            let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
                            setReferentData({ ...referentData,  countryCode: event.target.value, phoneCountry: pc });
                        }}>
                            {
                                Object.keys(contriesList.getData()).map((country, index) => {
                                    let dialCode = countryTelData.allCountries[countryTelData.iso2Lookup[country.toLowerCase()]].dialCode;
                                    return (
                                        <option key={index} value={dialCode}>{countries.getName(country, "fr", {select: "official"})} (+{dialCode})</option>
                                    );
                                })
                            }
                        </select>
                        <input type="tel" className="form-control rounded" id={"PhoneNumber" + refIndex} placeholder="00 00 00 00 00" value={parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry) !== undefined ? parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry).formatNational() : referentData.phoneNumber} aria-describedby="telephoneHelpBlock"
                            onChange={(e) => {
                                if(e.target.value !== ""){
                                    const phoneInput = document.getElementById("PhoneNumber" + refIndex);
                                    const parsedPhoneNumber = parsePhoneNumber("+" + referentData.countryCode + e.target.value);
                                    if(R.isNil(parsedPhoneNumber) || !isValidPhoneNumber(parsedPhoneNumber.number)){
                                        phoneInput.setCustomValidity("Numéro de télephone invalide.");
                                    }else if(parsedPhoneNumber.number === user.user.phoneNumber){
                                        phoneInput.setCustomValidity("Le numéro de téléphone du référent ne peut être le même que celui du dossier.");
                                    }else if(!R.isNil(user.referents.find((referent) => referent.phoneNumber === parsedPhoneNumber.number))){
                                        phoneInput.setCustomValidity("Il existe déjà un référent avec ce même numéro de téléphone.");
                                    }else{
                                        phoneInput.setCustomValidity("");
                                    }
                                }
                                setReferentData({ ...referentData, phoneNumber: e.target.value })
                            }}/>
                    </div>
                    {
                        wasValidated && document.getElementById("PhoneNumber" + refIndex)?.validity.valid === false ?
                        <div className={"invalid-feedback alert-danger alert d-block"}>
                            {
                                document.getElementById("PhoneNumber" + refIndex)?.validationMessage
                            }
                        </div>
                        : ""
                    }
                    
                </div>

               
                <div className="form-inline mb-3">
                    <div className="custom-control custom-radio custom-control-inline mr-6">
                        <input required type="radio" id={"Madame"+refIndex} name="SexMadameMonsieur" className="custom-control-input" defaultChecked={referentData.gender === gender.female} onClick={(e) => {
                            setReferentData({ ...referentData, gender: gender.female });
                        }} />
                        <label className="custom-control-label" htmlFor={"Madame"+refIndex}>Madame</label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                        <input type="radio" id={"Monsieur"+refIndex} name="SexMadameMonsieur" className="custom-control-input" defaultChecked={referentData.gender === gender.male} onClick={(e) => {
                            setReferentData({ ...referentData, gender: gender.male });
                        }} />
                        <label className="custom-control-label" htmlFor={"Monsieur"+refIndex}>Monsieur</label>
                    </div>
                </div>
                <div className="form-row">

                    <div className="form-group col-12 col-sm-6 col-xl">
                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Prenom" + refIndex}>Prénom</label>
                        <input required type="text" className="form-control" id={"Prenom" + refIndex} defaultValue={referentData.firstName} onChange={(e) => {
                            e.preventDefault();
                            setReferentData({ ...referentData, firstName: e.target.value });
                        }} pattern={RegexFields.nameWithoutNumbers}/>
                    </div>
                    <div className="form-group col-12 col-sm-6 col-xl">
                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Nom" + refIndex}>Nom</label>
                        <input required type="text" className="form-control" id={"Nom" + refIndex} defaultValue={referentData.lastName} onChange={(e) => {
                            e.preventDefault();
                            setReferentData({ ...referentData, lastName: e.target.value });
                        }} pattern={RegexFields.nameWithoutNumbers}/>
                    </div>

                    <div className="form-group col-12 col-sm col-lg-auto col-xl">
                        <label className="h6 font-weight-bolder my-auto" htmlFor={"naissance" + refIndex}>Date de naissance</label>
                        <DateWithModal isRequired={true} selectedDate={referentData.birthDate} setSelectedDate={(d) => setReferentData({ ...referentData, birthDate: d })} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-12 col-sm">
                        <div className="flex-row gx-2 align-items-center mb-1">
                            <label className="h6 font-weight-bolder my-auto" htmlFor={"Adresse" + refIndex}>Adresse</label>
                            {/* <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p> */}
                        </div>
                        <input required type="text" className="form-control" id={"Adresse"+refIndex} defaultValue={referentData.address} onChange={(event) => {
                            setReferentData({ ...referentData, address: event.target.value })
                        }} />
                    </div>
                </div>
                <div className="form-row">
                    <PostalCityInput
                        postalCode={referentData.zipCode}
                        city={referentData.city}
                        country={referentData.country}
                        onChange={(data) => {
                            setReferentData({ ...referentData, zipCode: data.postalCode, city: data.city });
                        }}
                        postalCodePattern={RegexFields.frenchZipCode}
                        customClasses={{
                            postalCode: "col-12 col-sm col-xl",
                            city: "col-12 col-sm col-xl"
                        }}
                        postalCodeId={"Postal" + refIndex}
                        cityId={"Ville" + refIndex}
                        postalCodeRequired={true}
                        cityRequired={true}
                        hasWrapper={false}
                    />
                </div>
                <div className="form-row">
                    <div className="form-group col-12 col-sm col-xl">
                        <label className="h6 font-weight-bolder my-auto" htmlFor={"naturalite"+refIndex}>Pays *</label>
                        <select className="custom-select" id={"naturalite"+refIndex} tabIndex={-98} defaultValue={referentData.country} onChange={(event) => {
                            setReferentData({ ...referentData, country: event.target.value });
                        }}>
                            {
                                Object.keys(contriesList.getData()).map((country, index) => {
                                    return (
                                        <option key={index} value={country}>{countries.getName(country, "fr", {select: "official"})}</option>
                                    );
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <label className="h6 font-weight-bolder" htmlFor={"ref"+refIndex}>Le référent est pour vous</label>
                    <div className="form-row">
                        <div className="form-group col-12 col-sm mb-2">
                            <div className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center"+(referentData.isLienFamilialDirect === true ? ' active': '')} name={"ref"+refIndex} 
                            onClick={() => {setReferentData({...referentData, isLienFamilialDirect: true, representativeType: undefined});}}>
                                <img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={liendirect} alt="lien familial direct" />
                                <h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
                            </div>
                        </div>
                        <div className="form-group col-12 col-sm mb-2">
                            <div className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center"+(referentData.representativeType === representativeType.other ? ' active': '')} name={"ref"+refIndex}
                            onClick={() => {setReferentData({...referentData, representativeType: representativeType.other, isLienFamilialDirect: false})}}>
                                <img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={autres} alt="autres" />
                                <h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
                            </div>
                        </div>
                    </div>
                    {
                        referentData.isLienFamilialDirect === true ?
                            <div className="form-group">
                                <label className="h6 font-weight-bolder text-uppercase" htmlFor="processus">TYPE DE lien</label>
                                <div className="form-inline mb-3">
                                    <div className="custom-control custom-radio custom-control-inline" onClick={() => {setReferentData({...referentData, representativeType: representativeType.child})}}>
                                        <input required type="radio" id="FilsFille" name="relationship" className="custom-control-input"  defaultChecked={referentData.representativeType === representativeType.child}/>
                                        <label className="custom-control-label" htmlFor="FilsFille">Fils/Fille</label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline" onClick={() => {setReferentData({...referentData, representativeType: representativeType.parent})}}>
                                        <input type="radio" id="Parent" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.parent}/>
                                        <label className="custom-control-label" htmlFor="Parent">Parent</label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline" onClick={() => {setReferentData({...referentData, representativeType: representativeType.sibling})}}>
                                        <input type="radio" id="FrèreSoeur" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.sibling} />
                                        <label className="custom-control-label" htmlFor="FrèreSoeur">Frère/Soeur</label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline" onClick={() => {setReferentData({...referentData, representativeType: representativeType.spouse})}}>
                                        <input type="radio" id="Conjoint" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.spouse} />
                                        <label className="custom-control-label" htmlFor="Conjoint">Conjoint</label>
                                    </div>
                                </div>
                            </div>
                            : ''
                    }
                    <div className={"invalid-feedback alert-danger alert" + (referentData.representativeType === undefined && wasValidated === true ? ' d-block' : '')}>
                        Veuillez choisir une option
                                            </div>
                </div>
            
                <div className="form-row text-right mt-4 mx-auto justify-content-end">
                    {isNew === true ? '' :
                        <React.Fragment>
                            <button type="button" className="btn btn-light text-muted px-3 mr-auto" onClick={() => { setIsEditing(isEditing.filter(e => e !== referentData.id)); }}>Annuler</button>
                            
                            {authFacilitaPage ? '' :
                                <button type="button" className="btn btn-alert-danger border-none px-3 mr-2" data-toggle="modal" data-target="#deleteReferent">Supprimer</button>
                            }
                        </React.Fragment>
                    }
                    {inModal === true ? 
                        ''
                        :
                        <button type="button" className="btn btn-info" onClick={async (event) => {
                            event.preventDefault();

                            if (referentForm.current.checkValidity()) {
                                
                                let parsedPhoneNumber = null;
                                // Check if phone number is actually entered (not just empty or whitespace)
                                const hasPhoneNumber = !R.isNil(referentData.phoneNumber) && referentData.phoneNumber.trim() !== "";
                                
                                if(hasPhoneNumber){
                                    parsedPhoneNumber = parsePhoneNumber("+" + referentData.countryCode + referentData.phoneNumber);
                                }

                                // For non-main representatives, if only country code is filled (no actual phone number), send null
                                let phoneNumberToSend = null;
                                if (referentData.isMainRepresentative || hasPhoneNumber) {
                                    phoneNumberToSend = R.isNil(parsedPhoneNumber) ? null : parsedPhoneNumber.formatInternational().replace(/ /g,'');
                                }

                                let userRepresentative = {
                                    gender : referentData.gender,
                                    firstName : referentData.firstName,
                                    lastName : referentData.lastName,
                                    birthDate: referentData.birthDate,
                                    email: referentData.email,
                                    representativeType: referentData.representativeType,
                                    isMainRepresentative: referentData.isMainRepresentative,
                                    userId: user.user.id,
                                    id: referentData.id,
                                    tmpRef: referentData.tmpRef,
                                    phoneNumber: phoneNumberToSend
                                };
                               
                                let userRepresentativeAddress = {
                                    addressLine1: referentData.address,
                                    addressLine2: '',
                                    postalCode: referentData.zipCode,
                                    city: referentData.city,
                                    country: referentData.country,
                                    id: !R.isNil(data.address) ? data.address.id : undefined
                                }
                                if (!R.isNil(referentData.id) && !authFacilitaPage){
                                    //update
                                    async function update(){
                                        await dispatch(updateRepresentative(userRepresentative));
                                        await dispatch(updateUserRepresentativeAddress(referentData.id, userRepresentativeAddress));
                                        setIsEditing(isEditing.filter(e => e !== referentData.id));
                                    }
                                    update();
                                }
                                // if (!R.isNil(referentData.id) && authFacilitaPage) {
                                //     //update edit auth/facilita page
                                //     async function update(){
                                //         // await dispatch(updateUser(userRepresentative));
                                //         // await dispatch(updateAddress(referentData.id, userRepresentativeAddress));
                                //         setIsEditing(isEditing.filter(e => e !== referentData.id));
                                        
                                //     }
                                //     update();
                                // }
                                else{
                                    //add
                                    dispatch(addUserRepresentative(userRepresentative))
                                    .then(() => {
                                        let tmpRefIndex = user.referents.findIndex(r => r.tmpRef !== undefined && r.tmpRef === data.tmpRef);
                                        if(tmpRefIndex !== -1){
                                            dispatch(addUserRepresentativeAddress(user.referents[tmpRefIndex].id, userRepresentativeAddress))
                                        }
                                        if(isNew === true){
                                            setNewReferent(false);
                                        }
                                    })                                    
                                }
                            }
                            if(!R.isNil(referentForm) && !R.isNil(referentForm.current) && !R.isNil(referentForm.current.classList)){
                                referentForm.current.classList.add('was-validated');
                            }
                            setWasValidated(true);
                            }}>Sauvegarder</button>
                    }
                </div>
            </form>
            <DeleteModal referent={referentData}/>
        </div>
    )
}